import React from "react";
import { Spinner } from "react-bootstrap";

const ScheduleTabContent = ({
  formData,
  isSubmitting,
  isRunNow,
  onChange,
  onSubmit,
}) => (
  <div className="card shadow-sm w-100">
    <div className="card-body p-4">
      <form onSubmit={onSubmit}>
        <div className="row g-3">
          <div className="col-md-3">
            <label htmlFor="schedule_frequency" className="form-label">
              Frequency
            </label>
            <select
              id="schedule_frequency"
              className="form-select"
              value={formData.frequency}
              onChange={onChange("frequency")}
              disabled={isSubmitting}
            >
              <option value="RUN NOW">RUN NOW</option>
              <option value="DAILY">DAILY</option>
            </select>
          </div>

          <div className="col-md-6">
            <label htmlFor="schedule_campaign_id" className="form-label">
              Campaign ID
            </label>
            <input
              id="schedule_campaign_id"
              type="text"
              className="form-control"
              value={formData.campaign_id}
              onChange={onChange("campaign_id")}
              placeholder="Enter campaign ID"
              disabled={isSubmitting}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="report_name" className="form-label">
              Report Name
            </label>
            <input
              id="report_name"
              type="text"
              className="form-control"
              value={formData.report_name}
              onChange={onChange("report_name")}
              placeholder="Enter report name"
              disabled={isSubmitting}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="schedule_recipients" className="form-label">
              Recipients
            </label>
            <input
              id="schedule_recipients"
              type="text"
              className="form-control"
              value={formData.recipients}
              onChange={onChange("recipients")}
              placeholder="Enter emails separated by comma"
              disabled={isSubmitting}
            />
          </div>

          {!isRunNow && (
            <>
              <div className="col-md-6">
                <label htmlFor="schedule_start_date" className="form-label">
                  Start Date
                </label>
                <input
                  id="schedule_start_date"
                  type="date"
                  className="form-control"
                  value={formData.start_date}
                  onChange={onChange("start_date")}
                  disabled={isSubmitting}
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="schedule_end_date" className="form-label">
                  End Date
                </label>
                <input
                  id="schedule_end_date"
                  type="date"
                  className="form-control"
                  value={formData.end_date}
                  onChange={onChange("end_date")}
                  disabled={isSubmitting}
                />
              </div>
            </>
          )}

          {!isRunNow && (
            <div className="col-md-2">
              <label htmlFor="schedule_execution_time" className="form-label">
                Execution Hour (UTC)
              </label>
              <input
                id="schedule_execution_time"
                type="number"
                min="0"
                max="23"
                step="1"
                className="form-control"
                value={formData.execution_time}
                onChange={onChange("execution_time")}
                disabled={isSubmitting}
                placeholder="0-23"
                style={{ maxWidth: "110px" }}
              />
            </div>
          )}

          {!isRunNow && (
            <div className="col-md-4 d-flex align-items-end">
              <div className="form-check mb-2">
                <input
                  id="schedule_only_form_data"
                  type="checkbox"
                  className="form-check-input"
                  checked={Boolean(formData.only_form_data)}
                  onChange={onChange("only_form_data")}
                  disabled={isSubmitting}
                />
                <label htmlFor="schedule_only_form_data" className="form-check-label">
                  Only Form Data
                </label>
              </div>
            </div>
          )}
        </div>

        <button type="submit" className="btn btn-primary w-100 mt-4" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Scheduling...
            </>
          ) : (
            "Schedule Report"
          )}
        </button>
      </form>
    </div>
  </div>
);

export default ScheduleTabContent;
